<template>
  <div class="body1">
    <div class="content">
      <div class="title">A REVOLUTIONARY CONCEPT</div>
      <div class="desc">E-Blocks is one of the extraordinary educational products<br/>developed by Pisitivo. Our multi-sensory program introduce<br/>children to Math, English as a second language and first<br/>literacy exposure.    </div>
      <img class="img" src="../../assets/eblock-02.png">
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {

  },
  methods: {}
}
</script>


<style scoped lang="less">
@import "../../assets/style/index";

.body1{
  height: 768px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: url("../../assets/body2-bg.png") no-repeat;
  background-size: 100% 60%;
  .content{
    .media-content;
    height: 100%;
    position: relative;
    color: white;
    .title{
      font-size: 38px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 50px;
      position: absolute;
      top: 144px;
      right: 0;
      letter-spacing: 0;
    }
    .desc{
      font-size: 18px;
      line-height: 30px;
      font-family: 'ArialMT', Helvetica, Arial, sans-serif;
      position: absolute;
      top: 245px;
      right: 0;
      letter-spacing: 0;
    }
    .img{
      width: 50%;
      height: 659px;
      position: absolute;
      top: 75px;
      object-fit: contain;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/e-body2.vue